import React from 'react'
import SideNav from './SideNav'

const BedroomDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-bedroom-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Bedroom Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/bedroom-designs.jpg" alt="Bedroom Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      Your bedroom is your private escape — a space to unwind, recharge, and dream. 
                      At <b>MeHome</b>, we craft bedroom interiors that blend comfort, elegance, and personality, 
                      designed to make every night peaceful and every morning refreshing.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Designing <span>Comfort with Character</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Every design detail, from furniture layout to lighting placement, is thoughtfully planned. 
                      We create bedrooms that match your rhythm — whether minimalist, luxurious, or contemporary.
                    </p>

                    <ul>
                      <li>Personalized design concepts for master and guest bedrooms.</li>
                      <li>Custom-built beds, wardrobes, and headboards for perfect harmony.</li>
                      <li>Elegant lighting, soft furnishings, and cozy textures.</li>
                      <li>Optimized floor plans for spacious, airy comfort.</li>
                      <li>Premium materials with long-lasting durability.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Specialized <span> Bedroom Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🛏️</div>
                        <div className="why-choose-item-content">
                          <h3>Master Bedrooms</h3>
                          <p>
                            Spacious and elegant designs featuring custom wardrobes, accent walls, and ambient lighting 
                            for a luxurious, restful experience.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">👧</div>
                        <div className="why-choose-item-content">
                          <h3>Kids & Guest Bedrooms</h3>
                          <p>
                            Fun, functional, and cozy — designed with creativity, color, and intelligent storage to 
                            make every corner joyful and useful.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🪵</div>
                        <div className="why-choose-item-content">
                          <h3>Wardrobes & Storage</h3>
                          <p>
                            Modular wardrobes and dressing units that combine maximum storage capacity with elegant finishes 
                            and smooth functionality.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Lighting & Decor</h3>
                          <p>
                            Layered lighting, cozy textures, and warm tones that create an intimate atmosphere for peaceful nights 
                            and beautiful mornings.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">🎨</div>
                        <div className="why-choose-item-content">
                          <h3>Custom Themes</h3>
                          <p>
                            From modern to traditional, rustic to minimalist — we create personalized bedroom themes that reflect 
                            your taste and lifestyle.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-gallery wow fadeInUp" data-wow-delay="0.6s">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Recent <span> Bedroom Projects</span>
                      </h2>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/bedroom1.jpg" alt="Bedroom Project 1" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/bedroom2.jpg" alt="Bedroom Project 2" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/bedroom3.jpg" alt="Bedroom Project 3" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Choose <span> MeHome for Bedroom Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>15+ Years of Expertise</b> in crafting elegant interiors.</li>
                        <li><b>Customized Bedroom Layouts</b> that enhance comfort and aesthetics.</li>
                        <li><b>Premium Furniture & Finishes</b> built for long-lasting appeal.</li>
                        <li><b>End-to-End Solutions</b> — from design to execution.</li>
                        <li><b>Affordable Luxury</b> for every budget size.</li>
                        <li><b>On-Time Project Completion</b> with smooth installation.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default BedroomDesigns
